module.exports = __webpack_public_path__ + "img/what-to-expect-hero-desktop@2x.0f2c56e9.png";